import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Paper, Grid, Link, Typography, Divider, Button } from '@mui/material';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
const classes = {
    root: {
        flexGrow: 1,
    },
    title: {
        color: 'rgba(0, 0, 0, 0.87)',
        marginTop: '5px',
        marginBottom: '-5px',
    },
    subtitle: {
        margin: '10px 0px 5px 5px',
    },
    paragraph: {
        color: 'rgba(0, 0, 0, 0.6)',
        padding: '0 5px',
    },
    card: {
        padding: '10px 40px',
        textAlign: 'center',
        color: 'rgba(0, 0, 0, 0.6)',
        height: '450px',
        width: '350px',
        position: 'relative',
    },
    cardSubtitle: { marginBottom: '15px', marginTop: '-5px' },
    cardList: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        padding: '10px 0 10px 20px',
        border: '1px solid #e6e6e6',
    },
    cardRow: { padding: '8px' },
    checkIcon: { verticalAlign: 'middle', paddingRight: '8px' },
};
const Aims = () => {
    return (React.createElement(Typography, { sx: classes.paragraph },
        "The aim of Climate4impact portal is to enhance the use of climate research data. It is currently under development in the European project IS-ENES3. Climate4impact is connected to the",
        React.createElement(Link, { href: 'https://esgf.llnl.gov/mission.html', target: '_blank', rel: 'noopener', style: { margin: '0 10px' } }, "Earth System Grid Federation (ESGF) infrastructure"),
        "using ESGF search and thredds catalogs. The portal aims to support climate change impact modellers, impact and adaptation consultants, as well anyone else wanting to use climate change data."));
};
export const LandingPage = ({ user, }) => {
    return (React.createElement("div", { style: classes.root },
        React.createElement(Grid, { container: true, spacing: 5 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { sx: classes.title, variant: 'h3', align: 'center', gutterBottom: true }, user && user.preferred_username ? (React.createElement("span", null,
                    "Welcome to Climate4Impact,",
                    React.createElement("span", { style: { color: '#3E51B5', fontStyle: 'italic' } }, ` ${user.preferred_username}`))) : (React.createElement("span", null, "Welcome to Climate4Impact!"))),
                React.createElement(Typography, { variant: 'h6', sx: classes.subtitle }, "Aims"),
                React.createElement(Aims, null),
                React.createElement(Typography, { variant: 'h6', sx: classes.subtitle }, "Choose your account type"),
                React.createElement(Typography, { sx: classes.paragraph }, "Accounts are free of charge. Guest accounts can browse the data and download link collections to be used in download managers. Registered users have access to the full range of services providing a fully managed Jupyter notebook environment for scientific research.")),
            React.createElement(Grid, { container: true, sx: { justifyContent: 'center' }, spacing: 6 },
                React.createElement(Grid, { item: true, xs: 4 },
                    React.createElement(Paper, { sx: classes.card },
                        React.createElement(Typography, { sx: classes.title, variant: 'h6' }, "Guest"),
                        React.createElement(Typography, { sx: classes.cardSubtitle, variant: 'subtitle1' }, "Limited features"),
                        React.createElement("div", { style: { margin: '0 auto' } },
                            React.createElement("div", { style: classes.cardList },
                                React.createElement("div", { style: classes.cardRow },
                                    React.createElement(CheckBoxOutlinedIcon, { sx: classes.checkIcon }),
                                    "Browse ESGF Data"),
                                React.createElement("div", { style: classes.cardRow },
                                    React.createElement(CheckBoxOutlinedIcon, { sx: classes.checkIcon }),
                                    "Download file links"))),
                        React.createElement("div", { style: {
                                position: 'absolute',
                                width: 350,
                                bottom: 10,
                            } },
                            React.createElement(Button
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            , { 
                                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                component: RouterLink, to: '/project', variant: 'contained', color: 'primary' }, "Browse Data")))),
                React.createElement(Grid, { item: true, xs: 3 },
                    React.createElement(Paper, { sx: classes.card },
                        React.createElement(Typography, { sx: classes.title, variant: 'h6' }, "Registered User"),
                        React.createElement(Typography, { sx: classes.cardSubtitle, variant: 'subtitle1' }, "Full feature access"),
                        React.createElement("div", { style: classes.cardList },
                            React.createElement("div", { style: classes.cardRow },
                                React.createElement(CheckBoxOutlinedIcon, { sx: classes.checkIcon }),
                                "Browse ESGF Data"),
                            React.createElement("div", { style: classes.cardRow },
                                React.createElement(CheckBoxOutlinedIcon, { sx: classes.checkIcon }),
                                "Download file links"),
                            React.createElement(Divider, { style: { margin: 10 } }),
                            React.createElement("div", { style: classes.cardRow },
                                React.createElement(CheckBoxOutlinedIcon, { sx: classes.checkIcon }),
                                "Access data in",
                                React.createElement(Link, { href: 'https://jupyter.org/', target: '_blank', rel: 'noopener', style: { margin: '0 4px' } }, "Jupyter"),
                                "workspace"),
                            React.createElement("div", { style: classes.cardRow },
                                React.createElement(CheckBoxOutlinedIcon, { sx: classes.checkIcon }),
                                "Access scientific",
                                React.createElement(Link, { href: 'https://gitlab.com/is-enes-cdi-c4i/notebooks', target: '_blank', rel: 'noopener', style: { margin: '0 4px' } }, "notebook presets")),
                            React.createElement("div", { style: classes.cardRow },
                                React.createElement(CheckBoxOutlinedIcon, { sx: classes.checkIcon }),
                                "Subset large datasets"),
                            React.createElement("div", { style: classes.cardRow },
                                React.createElement(CheckBoxOutlinedIcon, { sx: classes.checkIcon }),
                                "Create",
                                React.createElement(Link, { href: 'https://mybinder.org/', target: '_blank', rel: 'noopener', style: { margin: '0 4px' } }, "Binder"),
                                "snapshots of your work"),
                            React.createElement("div", { style: classes.cardRow },
                                React.createElement(CheckBoxOutlinedIcon, { sx: classes.checkIcon }),
                                "Trace and rollback operations")),
                        React.createElement(Button
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        , { 
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            component: RouterLink, to: '/register', variant: 'contained', color: 'primary', style: { marginTop: 15 } }, "Register")))))));
};
